import { useState, useEffect } from 'react';
import ContactPopup from '../../components/feature/ContactPopup';
import Header from './components/Header';
import WhyStudentsLoveIt from './components/WhyStudentsLoveIt';
import PerfectFor from './components/PerfectFor';
import TheShow from './components/TheShow';
import MediaSection from './components/MediaSection';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function CollegePage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-zinc-950">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className={`text-2xl font-bold transition-colors duration-300 cursor-pointer ${
            isScrolled ? 'text-zinc-950' : 'text-white'
          }`}>
            THOMAS
          </a>
          
          <div className="flex items-center gap-6">
            <a
              href="/"
              className={`font-medium transition-colors duration-300 cursor-pointer ${
                isScrolled ? 'text-zinc-700 hover:text-red-600' : 'text-white hover:text-red-600'
              }`}
            >
              Home
            </a>
            <button
              onClick={() => setIsPopupOpen(true)}
              className={`font-medium transition-colors duration-300 cursor-pointer ${
                isScrolled ? 'text-zinc-700 hover:text-red-600' : 'text-white hover:text-red-600'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => setIsPopupOpen(true)}
              className="px-6 py-2 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Book Now
            </button>
          </div>
        </div>
      </nav>

      {/* Page Content */}
      <Header onContactClick={() => setIsPopupOpen(true)} />
      <MediaSection />
      <WhyStudentsLoveIt />
      <PerfectFor />
      <TheShow />
      <CTA onContactClick={() => setIsPopupOpen(true)} />
      <Footer />

      {/* Contact Popup */}
      <ContactPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
}
